import { render, staticRenderFns } from "./QuoteSubNav.vue?vue&type=template&id=7ea01482&scoped=true"
import script from "./QuoteSubNav.vue?vue&type=script&lang=js"
export * from "./QuoteSubNav.vue?vue&type=script&lang=js"
import style0 from "./QuoteSubNav.vue?vue&type=style&index=0&id=7ea01482&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7ea01482",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/flexiquote/flexiquote/uniqms-vue-app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('7ea01482')) {
      api.createRecord('7ea01482', component.options)
    } else {
      api.reload('7ea01482', component.options)
    }
    module.hot.accept("./QuoteSubNav.vue?vue&type=template&id=7ea01482&scoped=true", function () {
      api.rerender('7ea01482', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/quote/QuoteSubNav.vue"
export default component.exports